module.exports = __webpack_public_path__ + "img/ic_many_point.f88bd41a.svg";